define('glu/grid/body/emptyView',['require','../../itemView','../../locale','hbs!../text.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        locale = require('../../locale'),
        tpl = require('hbs!../text.hbs');

    return ItemView.extend({
        template: tpl,
        className: 'glu-content-empty',

        initialize: function(options) {
            this.resultsName = options.resultsName || locale.get('defaultResultsName');
        },

        templateHelpers: function() {
            var text = this.options.text,
                thereIsNoContent = locale.get('thereIsNoContent', this.resultsName);

            return {
                text: text || thereIsNoContent
            };
        }
    });
});

